import Lottie from "lottie-react";
import TElogo from "../../../assets/images/dod_logo.png";
import homeicon from "../../../assets/Lottie/Web designer setting up web layout.json";

const Home2=()=>{
    return(<>
    <div className="d-flex align-items-center justify-content-center">
        <div>
        <h1 className="text-center">Welcome to DOD !</h1>
        <p  className="text-center">Connecting CAs and professionals across India.</p>
        {/* <img className="user-login-logo" src={TElogo} alt="logo"/> */}
        <div style={{ width: "400px", height: "400px" }}>
          <Lottie animationData={homeicon} loop={true} />
        </div>

        </div>
    </div>
    </>)
};

export default Home2;